// AuthGuard.js

import React, { useState, useEffect } from 'react';
import API from './../api';
import { useDispatch, useSelector } from 'react-redux'; // Importe useSelector
import { updateUser } from './../redux/userSlice';
import { useLocation, Navigate } from 'react-router-dom';
const AdminGuard = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const location = useLocation();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    API.get('/admin/user').then(response => {

      dispatch(updateUser(response.data));
      setIsReady(true);
    }
    )
  }, [location]);
  return <>
    {isReady &&
      (user.isAdmin ? <> {children} </> : <></>)
    }
  </>;
};
export default AdminGuard;



//<Navigate to="/" />